import { render } from "./AddUser.vue?vue&type=template&id=6fb458e8&ts=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__